import { FILTER_PREFIX } from '@/constants';
import { getKeyWidthPrefix } from '@/utils';
import { FilterTypes } from '@servicepipe/ui-components';

export const monitoringObjectsFiltersConfig = [
  {
    id: 1,
    name: 'id',
    label: 'ID',
    type: FilterTypes.INPUT,
    value: '',
    width: '120px',
  },
  {
    id: 2,
    name: 'name',
    label: 'Client name',
    type: FilterTypes.INPUT,
    value: '',
    width: '200px',
  },
  {
    id: 3,
    name: 'monitoringObjectName',
    label: 'FlowCollector MO name',
    type: FilterTypes.INPUT,
    value: '',
    width: '250px',
  },
];

export const protectedProfilesFiltersConfig = [
  {
    id: 1,
    name: 'id',
    label: 'ID',
    type: FilterTypes.INPUT,
    value: '',
    width: '120px',
  },
  {
    id: 2,
    name: 'name',
    label: 'Client name',
    type: FilterTypes.INPUT,
    value: '',
    width: '200px',
  },
  {
    id: 3,
    name: 'profileName',
    label: 'Dosgate profile name',
    type: FilterTypes.INPUT,
    value: '',
    width: '240px',
  },
];

const getFilterValueFromQuery = (queryFilters, columnId) => {
  const filterKey = getKeyWidthPrefix(columnId, FILTER_PREFIX);

  return queryFilters.find((filter) => filter.id === filterKey)?.value ?? '';
};

export const mergeFiltersWithQueryParams = (filtersConfig, queryFilters) =>
  filtersConfig.map((filter) => ({
    ...filter,
    value: getFilterValueFromQuery(queryFilters, filter.name),
  }));

export const filtersListToColumnFiltersState = (filtersList) =>
  filtersList.map((filter) => ({
    id: filter.name,
    value: filter.value || '',
  }));
